// extracted by mini-css-extract-plugin
export default {"AllCourses":"AllCourses_AllCourses__DnmVB","AllCoursesDiv":"AllCourses_AllCoursesDiv__4HlEX","activeCtgr":"AllCourses_activeCtgr__QV+OX"};